<template>
  <div class="row">
    <div class="col-lg-3">
      <div v-if="countFiltered > 0" class="search-results-header">{{ label_filters }}</div>
      <div v-if="countFiltered > 0" class="filters">
        <div id="filter-wrapper">
          <div class="filter">
            <div
              class="filter--header"
              @click="toggleTypeFilterExpanded()"
              :class="typeFilterExpanded ? 'expanded' : 'collapsed'"
            >{{ label_refine_your_search }}</div>
            <div class="filter--body" v-if="typeFilterExpanded">
              <div v-for="type in types">
                <label>
                  <input
                    type="checkbox"
                    :id="`filter-type-${type}`"
                    :value="type"
                    v-model="typeFilters"
                  />
                  {{ type }}
                </label>
              </div>
            </div>
          </div>
          <button
            class="reset btn btn-blue-outline-blue"
            @click="resetFilters()"
          >{{ label_reset_filters }}</button>
        </div>
      </div>
    </div>
    <div class="col-lg-9">
      <div
        class="search-results-header"
      >{{ label_results }} {{ label_for }} {{ query }} ({{ countFiltered }} {{ label_of }} {{ countAll }})</div>
      <div v-for="result in pageOfItems" class="search-results-item">
        <div v-if="!result.isObsolete">
          <!-- div class="search-results-category">{{ result.type }}</div -->
          <div class="image"><img :src=" result.image " class="search-thb" /></div>
          <div class="content-block">
            <a :href="result.url">
            <div class="search-results-name"> <span v-if="result.type === 'Product'">{{ result.stockCode }} &dash; </span> {{ result.title }}</div>
            </a>
            <p v-html="result.shortDescription"></p>
            <p><a :href="result.url" class="btn btn-hover pull-left btn-primary">{{ label_view }} {{ result.type }}</a></p>
          </div>
        </div>
      </div>
      <div v-if="countFiltered === 0">{{ label_no_results }}.</div>

       <jw-pagination :items="resultsFiltered" @changePage="onChangePage" :pageSize='pageSize' :initialPage='1' :labels="customLabels"></jw-pagination>
    </div>

  </div>
</template>

<script>

const customLabels = {
    first: '<<',
    last: '>>',
    previous: '<',
    next: '>'
};


export default {
  name: "search-results",
  props: {
    results: Array,
    query: String,
    label_filters: {
      type: String,
      required: true,
      default: "Filters"
    },
    label_reset_filters: {
      type: String,
      required: true,
      default: "Reset Filters"
    },
    label_refine_your_search: {
      type: String,
      required: true,
      default: "Refine your search"
    },
    label_results: {
      type: String,
      required: true,
      default: "Results"
    },
    label_for: {
      type: String,
      required: true,
      default: "for"
    },
    label_of: {
      type: String,
      required: true,
      default: "of"
    },
    label_no_results: {
      type: String,
      required: true,
      default: "No results"
    },
    label_view: {
        type: String,
        required: true,
        default: "View"
    },
    pageSize: {
        type: Number,
        default: 20
    }
  },
  data() {
    return {
      typeFilters: [],
      typeFilterExpanded: true,
       pageOfItems: [],
       customLabels
    };
  },
  computed: {
    resultsAll() {
      return this.results.map(x => x.model);
    },
    countAll() {
      return this.resultsAll.length;
    },
    types() {
      return this.resultsAll
        .map(x => x.type)
        .filter((item, i, ar) => ar.indexOf(item) === i);
    },
    resultsFiltered() {
      
      return this.resultsAll.filter(x => {
        var ts = this.typeFilters;
        if (ts.length < 1) {
          return true;
        } else {
          return ts.includes(x.type);
        }
      });
    },
    countFiltered() {
      return this.resultsFiltered.length;
    }
  },
  methods: {
    toggleTypeFilterExpanded() {
      this.typeFilterExpanded = !this.typeFilterExpanded;
    },
    resetFilters() {
      this.typeFilters = [];
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style>
.search-results-item {
  border-top: 1px solid #ccc;
  overflow: hidden;
  padding: 30px 0;
}
.search-results-item .image {
  width: 25%;
  float: left;
}
.search-results-item .image .search-thb {
  max-width: 170px;
  width: 100%;
}
.search-results-item .content-block {
  width: 75%;
  float: left;
}
.search-results-item .content-block p {
  color: #606060
}
.search-results-item .content-block .search-results-name {
    color: #005cb9;
    font-size: 20px;
}
</style>
